import ContactForm from "./ContactForm";

function Contact() {
  return (
    <section
      id="contact"
      className="py-20 px-6 md:px-12 lg:px-20 bg-hero-background border-l-4 border-green-600"
    >
      <div className="max-w-3xl mx-auto">
        <h2 className="font-display text-4xl md:text-5xl font-bold text-green-600 mb-6 text-center">
          Get in Touch
        </h2>
        <p className="font-body text-lg text-hero-foreground/80 mb-12 text-center max-w-2xl mx-auto">
          I'm actively seeking opportunities in{" "}
          <span className="font-semibold text-green-600">
            Software Engineer, Platform Engineer,and IT Engineer roles
          </span>
          . Based in{" "}
          <span className="font-semibold text-green-600">
            Salt Lake Valley, UT
          </span>
          . with openness to remote opportunities and, if needed, relocation.
        </p>

        <ContactForm />

        {/* Get in Touch Links */}
        <div className="text-center">
          <h3 className="font-display text-2xl font-bold text-hero-foreground mb-6">
            Other Ways to Connect
          </h3>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/resume-online"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-3 bg-hero-foreground text-hero-background font-semibold rounded-lg hover:opacity-90 transition-opacity"
            >
              Resume
            </a>
            <a
              href="https://www.linkedin.com/in/jack-aguilera/"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-3 border-2 border-hero-foreground text-hero-foreground font-semibold rounded-lg hover:bg-hero-foreground hover:text-hero-background transition-colors"
            >
              Connect on LinkedIn
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
